module.exports = __webpack_public_path__ + "static/milestonemugmain-ba5cd3164715fb715a50821280f4be3a.jpeg";